<template>
  <div style="position: relative;">
    <el-form ref="workInformationFilter" :model="workInformation" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="姓名" prop="formFilter.createUserName">
          <el-input class="filter-item" v-model="workInformation.formFilter.createUserName"
            :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="日期" prop="formFilter.createTime">
          <date-range class="filter-item" v-model="workInformation.formFilter.createTime" :clearable="true" :allowTypes="['day']" align="left"
                      range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                      format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetWorkInformation">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshWorkInformation(true)">查询</el-button>
<!--        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('workInformation:workInformation:batchDelete')"-->
<!--          @click="onBatchDeleteClick()">-->
<!--          批量删除-->
<!--        </el-button>-->
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="workInformation" :data="workInformation.WorkInformation.impl.dataList" :size="defaultFormItemSize" @sort-change="workInformation.WorkInformation.impl.onSortChange"
          header-cell-class-name="table-header-gray"
          @selection-change="onWorkInformationSelectionChange"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="workInformation.WorkInformation.impl.getTableIndex" />
<!--          <el-table-column type="selection"-->
<!--            header-align="center" align="center" width="55px"-->
<!--          />-->
          <el-table-column label="姓名" prop="createUser.showName">
          </el-table-column>
          <el-table-column label="内容" prop="workContent">
          </el-table-column>
          <el-table-column label="附件" min-width="180px">
            <template slot-scope="scope">
              <el-image v-for="item in parseUploadData(scope.row.attachedFiles, {id: scope.row.id, fieldName: 'attachedFiles', asImage: true})"
                :preview-src-list="getPictureList(scope.row.attachedFiles, {id: scope.row.id, fieldName: 'attachedFiles', asImage: true})"
                class="table-cell-image" :key="item.url" :src="item.url" fit="fill">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="工作地点" prop="workLocation">
          </el-table-column>
          <el-table-column label="时间" prop="createTime"></el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
<!--              <el-button @click.stop="onWorkInformationFormClick(scope.row)" type="text" :size="defaultFormItemSize"-->
<!--                :disabled="!checkPermCodeExist('workInformation:workInformation:workInformationForm')">-->
<!--                编辑-->
<!--              </el-button>-->
              <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                :disabled="!checkPermCodeExist('workInformation:workInformation:delete')">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="workInformation.WorkInformation.impl.totalCount"
            :current-page="workInformation.WorkInformation.impl.currentPage"
            :page-size="workInformation.WorkInformation.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="workInformation.WorkInformation.impl.onCurrentPageChange"
            @size-change="workInformation.WorkInformation.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { WorkInformationController, DictionaryController } from '@/api';

export default {
  name: 'workInformation',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      workInformation: {
        formFilter: {
          createUserName: undefined,
          createTime: undefined
        },
        formFilterCopy: {
          createUserName: undefined,
          createTime: undefined
        },
        WorkInformation: {
          deleteRows: [],
          impl: new TableWidget(this.loadWorkInformationWidgetData, this.loadWorkInformationVerify, true, false)
        },
        isInit: false
      }
    }
  },
  methods: {
    onResetWorkInformation () {
      this.$refs.workInformationFilter.resetFields();
      this.refreshWorkInformation(true);
    },
    /**
     * 实时农事工作日志表数据获取函数，返回Promise
     */
    loadWorkInformationWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        workInformationDtoFilter: {
          auditStatus: '1',
          createUserName: this.workInformation.formFilterCopy.createUserName,
          createTimeStart: Array.isArray(this.workInformation.formFilterCopy.createTime) ? this.workInformation.formFilterCopy.createTime[0] : undefined,
          createTimeEnd: Array.isArray(this.workInformation.formFilterCopy.createTime) ? this.workInformation.formFilterCopy.createTime[1] : undefined
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        WorkInformationController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 实时农事工作日志表数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadWorkInformationVerify () {
      this.workInformation.formFilterCopy.createUserName = this.workInformation.formFilter.createUserName;
      this.workInformation.formFilterCopy.createTime = this.workInformation.formFilter.createTime;

      return true;
    },
    onWorkInformationSelectionChange (values) {
      this.workInformation.WorkInformation.deleteRows = (values || []).map(item => {
        return item.id;
      });
    },
    /**
     * 更新工作日志
     */
    refreshWorkInformation (reloadData = false) {
      if (reloadData) {
        this.workInformation.WorkInformation.impl.refreshTable(true, 1);
      } else {
        this.workInformation.WorkInformation.impl.refreshTable();
      }
      if (!this.workInformation.isInit) {
        // 初始化下拉数据
      }
      this.workInformation.isInit = true;
    },
    /**
     * 工作日志表单
     */
    onWorkInformationFormClick (row) {
      let params = {
        id: row.id
      };

      params.closeVisible = 1;
      this.$router.push({name: 'workInformationForm', query: params});
    },
    /**
     * 批量删除
     */
    onBatchDeleteClick () {
      let params = {};

      if (!Array.isArray(this.workInformation.WorkInformation.deleteRows) || this.workInformation.WorkInformation.deleteRows.length <= 0) {
        this.$message.error('请选择要删除的数据！');
        return;
      }
      params.idList = this.workInformation.WorkInformation.deleteRows;
      this.$confirm('是否删除选中数据？').then(res => {
        WorkInformationController.deleteBatch(this, params).then(res => {
          this.$message.success('删除成功');
          this.workInformation.WorkInformation.impl.refreshTable(true, 1);
        }).catch(e => {});
      }).catch(e => {});
    },
    /**
     * 删除
     */
    onDeleteClick (row) {
      let params = {
        id: row.id
      };

      WorkInformationController.delete(this, params).then(res => {
        this.$message.success('删除成功');
        this.workInformation.WorkInformation.impl.refreshTable(false, 1);
      }).catch(e => {});
    },
    onResume () {
      this.refreshWorkInformation();
    },
    initFormData () {
    },
    formInit () {
      this.refreshWorkInformation();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
